import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  OnInit,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CaptchaVerificationDto } from '@shared/dtos/captcha-verification.dto';
import { CaptchaService } from '../../services/captcha.service';

@Component({
  selector: 'form-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CaptchaComponent),
      multi: true,
    },
  ],
})
export class CaptchaComponent implements OnInit, ControlValueAccessor {
  onChange: (value: CaptchaVerificationDto) => void = () => {};
  onTouched: Function = () => {};
  isDisabled = false;
  jpeg: string;

  public captchaVerificationDto: CaptchaVerificationDto = {
    uuid: '',
    answer: '',
  };

  constructor(
    private captchaService: CaptchaService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadCaptcha();
  }

  writeValue(value: CaptchaVerificationDto) {
    this.captchaVerificationDto = value || {
      uuid: '',
      answer: '',
    };
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean) {
    this.isDisabled = disabled;
  }

  loadCaptcha(): void {
    this.captchaVerificationDto.answer = '';
    this.captchaService.getCaptcha().subscribe((captcha) => {
      this.jpeg = `data:image/jpeg;base64,${captcha.jpeg}`;
      this.captchaVerificationDto.uuid = captcha.uuid;
      this.cdr.markForCheck();
    });
  }

  onValueChanges(answer: string) {
    this.captchaVerificationDto.answer = answer;
    this.onChange(this.captchaVerificationDto);
    this.onTouched();
  }
}
